<template>
  <div class="ic-forms">
    <div v-if="!isSent">
      <div class="ic-form__z-01">
        <FormWrapper :validator="$v.form">
          <IcRadioGroup id="trainType" v-model="form.trainType" :options="trainTypeOptions"
            @input="$emit('update:trainType ', $event)" outerClass="pull-left mr-5"></IcRadioGroup>

          <div class="my-3" v-if="form.trainType != ''">
            <h3>Dane zamawiającego</h3>
            <div class="row">
              <div class="col-12">
                <IcFormRowWrapper id="name" rowElement="IcFormRow" name="name" :aria="$t('aria_required')"
                  :label="$t('label_name_company')" :labelWidth="4" :controlWidth="8">
                  <template slot-scope="{validator}">
                    <IcInput id="name" v-model="form.name" @input="emitInput(form, validator)"></IcInput>
                  </template>
                </IcFormRowWrapper>
              </div>
              <div class="col-12 col-lg-6">
                <IcFormRowWrapper id="email" rowElement="IcFormRow" name="email" :aria="$t('aria_required')"
                  :label="$t('label_zamowienie_email')" :labelWidth="4" :controlWidth="8">
                  <template slot-scope="{validator}">
                    <IcInputEmail id="email" v-model="form.email" @input="emitInput(form, validator)"></IcInputEmail>
                  </template>
                </IcFormRowWrapper>
              </div>
              <div class="col-12 col-lg-6">
                <IcFormRowWrapper id="phone" rowElement="IcFormRow" name="phone" :aria="$t('aria_required')"
                  :label="$t('label_phone')" :labelWidth="4" :controlWidth="8">
                  <template slot-scope="{validator}">
                    <IcInputPhone id="phone" v-model="form.phone" @input="emitInput(form, validator)"></IcInputPhone>
                  </template>
                </IcFormRowWrapper>
              </div>
              <IcFormRowWrapper id="peopleCount" rowElement="IcFormRow" name="peopleCount" :aria="$t('aria_required')"
                :label="$t('label_peopleCount')" :labelWidth="4" :controlWidth="8">
                <template slot-scope="{validator}">
                  <IcInput id="peopleCount" v-model="form.peopleCount" @input="emitInput(form, validator)"></IcInput>
                </template>
              </IcFormRowWrapper>
              <div class="text-danger" v-if="form.peopleCount > 80 && form.trainType == 'carriage'">{{ $t('max_people_text') }}</div>
            </div>
          </div>
          <div class="my-3">
            <div v-if="form.trainType == 'carriage'">
              <IcFormCarriage v-model="form.carriages" :withCount="false" label="">
              </IcFormCarriage>
              <p style='display:none' :class="{'text-danger d-block': hasError('form.carriages')}">{{$t('validation_required')}}</p>
            </div>
            <div v-if="form.trainType == 'train'">
              <IcFormTrain v-model="form.train"/>
            </div>
          </div>

          <div class="my-3" v-if="form.trainType == 'carriage'">
            <IcFormSelectConnection v-model="form.connection" name="connection" label="Szczegóły przejazdu „TAM”"
              :withDelay="false" :withTicket="false" :minDate="minDate" :withTrain="true" />
              <p style='display:none' :class="{'text-danger d-block': hasError('form.connection')}">{{$t('validation_required')}}</p>

            <IcFormSelectConnection v-model="form.connection2" name="connection2" label="Szczegóły przejazdu „POWRÓT” (opcjonalnie – jeśli dotyczy)" 
              :withDelay="false" :withTicket="false" :minDate="minDate" :withTrain="true" />
              <p style='display:none' :class="{'text-danger d-block': hasError('form.connection2.departureDate')}">{{hasError('form.connection2.departureDate')}}</p>
          </div>
          <div class="my-3" v-if="form.trainType == 'train'">
            <IcFormContactConnection v-model="form.connection"  name="connection" :minDate="minDate" label="Szczegóły przejazdu „TAM”" :withDelay="false" :withTicket="false" :withTrain="false"/>
            <IcFormContactConnection v-model="form.connection2" name="connection2" label="Szczegóły przejazdu „POWRÓT” (opcjonalnie – jeśli dotyczy)"  :minDate="minDate" :withTicket="false" :withDelay="false"  :withTrain="false"/>
          </div>
          <div v-if="form.trainType != ''">
            <h3>Uwagi / informacje dodatkowe</h3>
            <IcFormRowWrapper id="message" rowElement="IcFormRow" name="message" :aria="$t('aria_required')"
              :label="$t('label_message')" :labelWidth="4" :controlWidth="8">
              <template slot-scope="{validator}">
                <IcTextarea id="message" v-model="form.message" @input="emitInput(form, validator)"></IcTextarea>
              </template>
            </IcFormRowWrapper>
            <IcFormAgreements v-model="form.agreement" :text="false" :header="false" 
              :label="$t('label_przetwarzanie_agreement')" >
            </IcFormAgreements>
            <IcFormAgreements v-model="form.agreement_taryfa" :text="false" :header="false" name="agreement_taryfa"
              :label="$t('label_taryfa_agreement')" >
            </IcFormAgreements>
            <IcFormAgreements v-model="form.agreement_contact" :text="false" :header="false" :modal="true" name="agreement_contact"
              :label="$t('label_contact_agreement')" >
              {{$t("label_rodo_agreement_body")}}
            </IcFormAgreements>
            <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />

          </div>

        </FormWrapper>
      </div>


    </div>

    <IcFormSentZamowienie v-if="isSent" :data="sentData" :header="$t('sent_zamowienie_header')" :text="$t('sent_zamowienie_text')"/>
  </div>
</template>
  
<script>
import IcFormsBase from "./Base/FormsBase";

import IcFormContactBase from "./Base/ContactBase";
import IcFormContactPhone from "./Base/Phone";
import IcFormContactEmail from "@/components/ic/form/contact/Base/Email";
import IcFormContactMessage from "@/components/ic/form/contact/Base/Message";
import IcFormContactFiles from "@/components/ic/form/contact/Base/Files";
import IcFormAgreements from "@/components/ic/form/contact/Base/Agreements";
import IcFormButtons from "@/components/ic/form/contact/Base/Buttons";
import validations from "./Validation/zamowienie-wagonu.js";
import Vue from "vue";
import icForm from "@/ic-common/mixins/icForm";
import IcInputEmail from "@/components/ic-common/form/controls/InputEmail";
import IcInputPhone from "@/components/ic-common/form/controls/InputPhone";
import IcFormRow from "@/components/ic-common/form/helpers/FormRow.vue";
import IcInput from "@/components/ic-common/form/controls/Input";
import IcTextarea from "@/components/ic-common/form/controls/Textarea";
import IcInputFile from "@/components/ic-common/form/controls/InputFile";
import IcInputFileInput from "@/components/ic-common/form/controls/InputFileInput";
import IcFormSentZamowienie from "@/components/ic/form/contact/Base/SentZamowienie";
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup";
import IcFormContactConnection from "./Base/Connection";
import IcFormSelectConnection from './Base/ConnectionSelect.vue';
import IcFormCarriage from "./Base/Carriage";
import IcFormTrain from "./Base/Train";
import { emitInput } from "./Base/mixins";
import get from "lodash/get";
import unset from "lodash/unset";
import forEach from "lodash/forEach";
import keys from "lodash/keys";
import moment from "moment";

const _ = { get, forEach, keys, unset };

export default {
  name: "IcFormsZamowienieWagonu",
  extends: IcFormsBase,
  mixins: [icForm],
  validations,
  props: {
    value: {
      type: Object
    },

  },
  data() {
    return {
      minDate: moment()
        .add(14, "days")
        .format("YYYY-MM-DD"),
      trainTypeOptions: [{ id: 'carriage', name: "Dołączenie wagonu" }, { id: 'train', name: "Uruchomienie pociągu" }],
      errors: {
        form: {}
      },
      group: "Zamowienie",
      form: {
        email: "",
      },
      formUrl: "/ax26hrxl857-a/components/icforms/connector.php?action=store",

    };
  },

  mounted() {
    this.reset();
  },
  computed: {
    trainTypeS() {
      return this.form.trainType;
    }
  },  
  watch: {
    trainTypeS(v,old){
      //console.log("v,old:",v,old)
      if(!old) return;
      this.form.agreement = "";
      this.form.agreement_taryfa = "";
      this.form.agreement_contact = "";
      this.reset(v);
      this.$v.$reset();
      //this.$v.$touch();
    },
    form: {
      handler: function (newValue, oldValue) {
        this.$emit("input", this.form);

      },
      deep: true
    },
  },
  methods: {
    reset(type = '') {
      this.form = Object.assign(
        {
          type: "zamowienie",
          email: "",
          name: "",
          phone: "",
          peopleCount: "",
          trainType: type,
          carriages: {},
          train: [],
          connection: [],
          connection2: [],
          message: "",
          remarks: "",
          agreement: "",
          agreement_taryfa: "",
          agreement_contact: "",
          participants: [],
          disabilities: [],
        },
        this.value
      );
      console.log(this.form);
      this.$emit("input", this.form);
    },
    emitInput,
    isRequired(field) {
      let v = _.get(this.$v, field.replace("[", ".$each["));
      //console.log(v);
      return false;
      // to jest bardzo źle, ale v.required zwraca false, jeśli jest pole puste
      return v.$params.required ? true : v.$params.requiredIf ? true : false;
    },
    hasError(field) {
      //console.log(this.$v,field.replace("[", ".$each["));
      let clientSide = _.get(this.$v, field.replace("[", ".$each["));
      let serverSide = _.get(this.errors, field);
      let message = "";
      console.log("{CLIENT SIDE}",field,clientSide.$error)
      if (clientSide && clientSide.$error) {
        // _.unset(this.errors,field);
        _.forEach(clientSide, (item, key) => {
          console.log(item,key);
          console.log(key[0] !== "$" , item === false);

          if (key[0] !== "$" && item === false) {
            let localMessageKey =
              "validation_" +
              field.replace("form.", "").replace(/\[[0-9]+\]/, "");
            let specificMessageKey = localMessageKey + "_" + key;
            let globalMessageKey = "validation_" + key;
            let params = clientSide.$params[key];

            message = this.$te(specificMessageKey)
              ? this.$t(specificMessageKey)
              : this.$te(localMessageKey)
                ? this.$t(localMessageKey)
                : this.$t(globalMessageKey);

            return message;
          }
        });
      } else if (serverSide) {
        message = serverSide;
      }

      if (clientSide && clientSide.$dirty && !clientSide.$error) {
        _.unset(this.errors, field);
        message = "";
      }

      return message;
    },
  },
  components: {
    IcFormContactPhone,
    IcFormContactEmail,
    IcFormContactMessage,
    IcFormContactFiles,
    IcFormAgreements,
    IcFormButtons,
    IcInputEmail,
    IcInput,
    IcFormRow,
    IcTextarea,
    IcInputFile,
    IcInputFileInput,
    IcInputPhone,
    IcRadioGroup,
    IcFormContactConnection,
    IcFormCarriage,
    IcFormTrain,
    IcFormSelectConnection,
    IcFormSentZamowienie
  }
};
</script>

<style lang="scss"></style>
